import { VisibleSection } from "components/common/VisibleSection";
import { ONE, THREE } from "domain/aboutYourLoan";
import {
  findRepaymentOption,
  RepaymentOption,
  RepaymentOptionType,
} from "domain/indicativeRepaymentOptions";
import {
  RepaymentHolidaysType,
  SelectedTreatmentsDetails,
} from "domain/selectedTreatments";
import { HideIfNoData } from "util/enhancer";
import { NullableField } from "util/extendedTypes";
import {
  RHChoicesExplained,
  RHExtendTermActiveOptions,
  CRHImportantInformation,
  CIRHImportantInformation,
} from ".";

export type RHExtendTermActiveProps = {
  CRHTaken: number;
  CIRHTaken: number;
  repaymentOptions: RepaymentOption[];
  selectedTreatments: SelectedTreatmentsDetails;
  checked: boolean;
  onChange: (selectedTreatments: SelectedTreatmentsDetails) => void;
  onChecked: (checked: boolean) => void;
};

export const RHExtendTermActive = ({
  repaymentOptions,
  selectedTreatments,
  checked,
  onChange,
  onChecked,
  CRHTaken,
  CIRHTaken,
}: RHExtendTermActiveProps) => {
  const getRepaymentOption = findRepaymentOption(repaymentOptions);
  const CRH =
    getRepaymentOption(RepaymentOptionType.CRHWithoutExtendTerm) || null;
  const CIRH =
    getRepaymentOption(RepaymentOptionType.CIRHWithoutExtendTerm) || null;

  const CRHVisible =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalRepaymentHoliday;
  const CIRHVisible =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalIntersestRepaymentHoliday;
  const RHVisible = CRHTaken < THREE && CIRHTaken < ONE;
  return (
    <>
      <VisibleSection visible={RHVisible}>
        <RHChoicesExplained />
      </VisibleSection>

      <RHExtendTermActiveOptions
        CRH={CRH}
        CIRH={CIRH}
        CRHTaken={CRHTaken}
        CIRHTaken={CIRHTaken}
        selectedTreatments={selectedTreatments}
        onChange={onChange}
      />
      <VisibleSection visible={CRHVisible}>
        <CRHImportantInformation
          selectedTreatments={selectedTreatments}
          checked={checked}
          onChecked={onChecked}
        />
      </VisibleSection>
      <VisibleSection visible={CIRHVisible}>
        <CIRHImportantInformation
          selectedTreatments={selectedTreatments}
          checked={checked}
          onChecked={onChecked}
        />
      </VisibleSection>
    </>
  );
};

export const RHExtendTermActiveComponent = HideIfNoData<
  RHExtendTermActiveProps,
  NullableField<RHExtendTermActiveProps, "CRHTaken" | "CIRHTaken">
>((p) => false)(RHExtendTermActive);
